import {
  AnalysisType,
  AnalysisTypeKey,
  HeatmapChartKey,
  IntervalsTypes,
  StepRangeKey,
  UnitOptionsKeys,
  ValueRangeKey,
  ZFilterKey,
} from '../../store/types';

export const RANGE_PARAMETERS = [
  { key: ValueRangeKey.WOB, label: 'Heatmap-range-wob' },
  { key: ValueRangeKey.DPRESS, label: 'Heatmap-range-dpress' },
  { key: ValueRangeKey.RPM, label: 'Heatmap-range-rpm' },
  { key: ValueRangeKey.RPMTOT, label: 'Heatmap-range-rpmtot' },
];

export const STEP_PARAMETERS = [
  {
    key: [StepRangeKey.WOB],
    label: 'Heatmap-step-wob',
    unitKey: UnitOptionsKeys.WOB,
  },
  {
    key: [StepRangeKey.DPRESS],
    label: 'Heatmap-step-dpress',
    unitKey: UnitOptionsKeys.DPRESS,
  },
  {
    key: [StepRangeKey.RPM, StepRangeKey.RPMTOT],
    label: 'Heatmap-step-rpm',
  },
];

export const ANALYSIS_TYPE_PARAMETERS = [
  {
    key: AnalysisTypeKey.ROP,
    label: 'Heatmap-analysis-rop',
    unitKey: UnitOptionsKeys.ROP,
  },
  {
    key: AnalysisTypeKey.MSE_BIT,
    label: 'Heatmap-analysis-mse-bit',
    unitKey: UnitOptionsKeys.MSE_BIT,
  },
  {
    key: AnalysisTypeKey.MSE_SURFACE,
    label: 'Heatmap-analysis-mse-surface',
    unitKey: UnitOptionsKeys.MSE_SURFACE,
  },
];

export const ANALYSIS_TYPE_OPTIONS = [
  { value: AnalysisType.MEDIAN, label: 'Heatmap-analysis-type-med' },
  { value: AnalysisType.Q10, label: 'Heatmap-analysis-type-q10' },
  { value: AnalysisType.Q90, label: 'Heatmap-analysis-type-q90' },
  { value: AnalysisType.Q25, label: 'Heatmap-analysis-type-q25' },
  { value: AnalysisType.Q75, label: 'Heatmap-analysis-type-q75' },
];

export const CHART_VISIBILITY_OPTIONS = [
  { key: HeatmapChartKey.ROP, label: 'Heatmap-visibility-rop' },
  { key: HeatmapChartKey.MSE, label: 'Heatmap-visibility-mse' },
  {
    key: HeatmapChartKey.DENSITY,
    label: 'Heatmap-visibility-density',
  },
];

export const INTERVAL_OPTIONS = [
  {
    value: IntervalsTypes.SECTIONS,
    label: 'Heatmap-interval-sections',
  },
  {
    value: IntervalsTypes.FORMATIONS,
    label: 'Heatmap-interval-formations',
  },
  {
    value: IntervalsTypes.STRAT_UNITS,
    label: 'Heatmap-interval-strat-units',
  },
  {
    value: IntervalsTypes.DRILLING_ANALYSIS,
    label: 'Heatmap-interval-drilling-analysis',
    shortLabel: 'Heatmap-interval-drilling-analysis-short',
  },
  {
    value: IntervalsTypes.USER_DEFINED,
    label: 'Heatmap-interval-user-defined',
  },
];

export const DRILLING_OPTIONS = [
  { value: 'load', label: 'Heatmap-drilling-load' },
  { value: 'drop_off', label: 'Heatmap-drilling-dropoff' },
];

export const Z_FILTER_ROTARY_PARAMETERS = [
  { key: ZFilterKey.ROTATION_ROP, label: 'Heatmap-filter-ropa' },
  { key: ZFilterKey.ROTATION_MSE, label: 'Heatmap-filter-smse' },
];

export const Z_FILTER_SLIDE_PARAMETERS = [
  { key: ZFilterKey.SLIDE_ROP, label: 'Heatmap-filter-ropa' },
  { key: ZFilterKey.SLIDE_MSE, label: 'Heatmap-filter-dmse' },
];
